import { generatePath, useParams } from "react-router";

import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import type { ParamParseKey } from "react-router";

export const useGetRoomI18nParams = () => {
	const { hotelID, roomID, langCode } = useParams<ParamParseKey<typeof PATHS.HOTEL.ITEMS.ROOM.EDIT.ROOM_ID.I18N>>();

	if (!hotelID || !roomID || !langCode) {
		throw Error("error");
	}

	const navigator = {
		default: generatePath(PATHS.HOTEL.ITEMS.ROOM.EDIT.ROOM_ID.DEFAULT, { hotelID, roomID }),
		i18n: (langCode: LangCode) =>
			generatePath(PATHS.HOTEL.ITEMS.ROOM.EDIT.ROOM_ID.I18N, { hotelID, roomID, langCode }),
	};

	const activeLangCode = langCode as LangCode;

	return {
		hotelID: hotelID,
		roomID,
		activeLangCode,
		navigator,
	};
};
